import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=b8dce334"
import script from "./GroupsList.vue?vue&type=script&lang=js"
export * from "./GroupsList.vue?vue&type=script&lang=js"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=b8dce334&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports